import React, { Fragment, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";

import Main from "layouts/Main";
import Container from "components/Container";
import { About, Features, Hero, Jobs, Newsletter } from "./components";

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";


const CareerListingMinimal = () => {
  const [transparenciaData, setTransparencia] = useState({
    title: "",
    description: "",
    image: "",
    acuerdos: {},
  });

  useEffect(() => {
    const db = firebase.firestore();
    const storage = firebase.storage();
    db.collection("transparencia").onSnapshot((querySnapshot) => {
      if (!querySnapshot.empty) {
        const transparencia = querySnapshot.docs[0].data();
        setTransparencia({
          title: transparencia.title,
          description: transparencia.description,
          image: transparencia.image,
          acuerdos: transparencia.acuerdos,
        });
      }
    });
  }, []);

  return (
    <Fragment>
      <Hero />
      <Container paddingY={"0 !important"}>
        <About />
      </Container>
      <Container>
        <Features title={transparenciaData.title} image={transparenciaData.image} acuerdos={transparenciaData.acuerdos} />
      </Container>
      <Box bgcolor={"alternate.main"}>
        <Container>
          <Jobs acuerdos={transparenciaData.acuerdos} />
        </Container>
      </Box>
      <Container></Container>
      <Divider />
    </Fragment>
  );
};

export default CareerListingMinimal;
